export default {"src":"/_next/static/media/calendar-rounded-icon.5644b881.svg","height":92,"width":93,"blurWidth":0,"blurHeight":0};